var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFpsHowto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7004 21.1539C12.7086 21.1539 14.6717 20.5584 16.3415 19.4427C18.0113 18.3269 19.3128 16.7411 20.0813 14.8858C20.8498 13.0304 21.0509 10.9888 20.6591 9.01913C20.2673 7.04947 19.3002 5.24023 17.8802 3.82019C16.4602 2.40015 14.6509 1.43309 12.6813 1.0413C10.7116 0.649511 8.67002 0.850591 6.81465 1.61911C4.95927 2.38763 3.37346 3.68908 2.25774 5.35887C1.14202 7.02866 0.546509 8.9918 0.546509 11C0.546509 13.693 1.61629 16.2757 3.5205 18.1799C5.42472 20.0841 8.00739 21.1539 10.7004 21.1539Z",
    fill: "#D7DADE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57245 9.63684H10.7004V15.5134H11.8283",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57245 9.63684H10.7004V15.5134H11.8283",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2773 7.61537C10.9783 7.61537 11.5465 7.04711 11.5465 6.34614C11.5465 5.64516 10.9783 5.0769 10.2773 5.0769C9.57631 5.0769 9.00806 5.64516 9.00806 6.34614C9.00806 7.04711 9.57631 7.61537 10.2773 7.61537Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2773 7.19231C10.7446 7.19231 11.1235 6.81347 11.1235 6.34615C11.1235 5.87884 10.7446 5.5 10.2773 5.5C9.80999 5.5 9.43115 5.87884 9.43115 6.34615C9.43115 6.81347 9.80999 7.19231 10.2773 7.19231Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpsHowto);
export default __webpack_public_path__ + "static/media/fps-howto.1981b265b9bfc6d276b5acc765a355d5.svg";
export { ForwardRef as ReactComponent };